/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Metric } from './Metric';
import {
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    MetricToJSONTyped,
} from './Metric';

/**
 * 
 * @export
 * @interface BranchAppsNetSalesResponse
 */
export interface BranchAppsNetSalesResponse {
    /**
     * 
     * @type {Array<Metric>}
     * @memberof BranchAppsNetSalesResponse
     */
    data: Array<Metric>;
}

/**
 * Check if a given object implements the BranchAppsNetSalesResponse interface.
 */
export function instanceOfBranchAppsNetSalesResponse(value: object): value is BranchAppsNetSalesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BranchAppsNetSalesResponseFromJSON(json: any): BranchAppsNetSalesResponse {
    return BranchAppsNetSalesResponseFromJSONTyped(json, false);
}

export function BranchAppsNetSalesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchAppsNetSalesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MetricFromJSON)),
    };
}

export function BranchAppsNetSalesResponseToJSON(json: any): BranchAppsNetSalesResponse {
    return BranchAppsNetSalesResponseToJSONTyped(json, false);
}

export function BranchAppsNetSalesResponseToJSONTyped(value?: BranchAppsNetSalesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MetricToJSON)),
    };
}

